"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppInfo = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const AppInfo = ({
  appDescription,
  appIcon,
  appName
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AppInfoRoot, {
    children: [appIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AppIcon, {
      "data-testid": getTestId(_constants.APP_PROMO_BANNER_ICON),
      src: appIcon,
      alt: appName ?? appIcon
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.ImagePlaceholder, {
      height: 60,
      width: 60
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AppNameAndDescription, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AppName, {
        id: _constants.APP_PROMO_BANNER_LABEL,
        color: "textPrimary",
        fontWeight: "bold",
        children: appName
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AppDescription, {
        variant: "caption",
        children: appDescription
      })]
    })]
  });
};
exports.AppInfo = AppInfo;
